import { createContext, useContext } from 'react';

export const ClinicalReportsContext = createContext(null);

export function useClinicalReports() {
  const ctx = useContext(ClinicalReportsContext);
  if (!ctx) {
    throw new Error('useClinicalReports must be used within a clinical reports layout');
  }
  return ctx;
}
